
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDieselGenerator as ObiDieselGeneratorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diesel-generator.js';
 
 
 

 
 export const ObiDieselGenerator = createComponent({
   react: React,
   tagName: 'obi-diesel-generator',
   elementClass: ObiDieselGeneratorElement,
   events: {
     
   }
  });
 
 